module.exports = __webpack_public_path__ + "static/img/spinner.1863796.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spinner.gif
// module id = 319
// module chunks = 1